import { Field, ObjectType, ID, InputType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { AppSettingScope } from './AppSettingScope'
import { generateEntityId } from '../generateEntityId'
import { BaseEntity } from '../base/BaseEntity'

@ObjectType()
@InputType('AppSettingInput')
export class AppSetting extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('set') })
  declare _id: string

  @Field(() => String)
  @Prop({ type: String, required: true })
  key: string

  @Field(() => String)
  @Prop({ type: String })
  value: string

  @Field(() => AppSettingScope)
  @Prop({ type: AppSettingScope })
  scope: AppSettingScope
}
